import React from "react";
import { Navbar, Container, Nav } from "react-bootstrap";
import instagram from "../../assets/instagramLogo.png";
import facebook from "../../assets/facebookLogo.png";
import linkedinLogo from "../../assets/linkedinLogo.png";
import { NavLink } from "react-router-dom";
import "./Navbar.css";
import logo from "../../assets/logo.png";
const NavBar = () => {
  const [expanded, setExpanded] = React.useState(false);

  return (
    <Navbar expand="lg" variant="dark" fixed="top" className="navbar-animation">
      <Container className="navbar-container">
        <Navbar.Brand to="/home" className="brand-logo socials">
          <NavLink to="/home" className="">
            <img src={logo} width="130px" alt="company logo" />
          </NavLink>
        </Navbar.Brand>
        <Navbar.Toggle
          aria-controls="responsive-navbar-nav"
          onClick={() => setExpanded(expanded ? false : "expanded")}
        />
        <Navbar.Collapse id="responsive-navbar-nav" expanded={expanded}>
          <Nav className="nav-links ">
            <NavLink to="/home" className="nav-link">
              Home
            </NavLink>
            <NavLink to="/services" className="nav-link">
              Services
            </NavLink>
            <NavLink to="/about" className="nav-link">
              About
            </NavLink>{" "}
            <Nav.Link
              href="https://www.instagram.com"
              target="_blank"
              className="socials"
            >
              <img src={instagram} width="35px" alt="company logo" />
            </Nav.Link>{" "}
            <Nav.Link
              href="https://www.facebook.com"
              target="_blank"
              className="socials"
            >
              <img src={facebook} width="45px" alt="company logo" />
            </Nav.Link>
            <Nav.Link
              href="https://www.twitter.com"
              target="_blank"
              className="socials"
            >
              <img src={linkedinLogo} width="35px" alt="company logo" />
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default NavBar;
